import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getClient } from '@chegg/rio-sdk-web';
import { trigger as clientCallback } from '../clientCallback';
import { EventTypes, recordEvents } from '../../utils/newRelicEvents';
var rioClient;
export function getRioClient() {
  rioClient = getClient();
  return rioClient;
}
export function sendRioEvent(_x, _x2) {
  return _sendRioEvent.apply(this, arguments);
}
function _sendRioEvent() {
  _sendRioEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(type, data) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return getRioClient().sendEvent({
            type: type,
            data: data,
            eventVersion: 3
          });
        case 3:
          clientCallback({
            type: 'log',
            payload: {
              type: type,
              data: data
            }
          });
          _context.next = 9;
          break;
        case 6:
          _context.prev = 6;
          _context.t0 = _context["catch"](0);
          recordEvents(_defineProperty({}, EventTypes.sendRioEventFail, {
            type: type,
            data: data
          }));
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 6]]);
  }));
  return _sendRioEvent.apply(this, arguments);
}
export function getUUID() {
  var uuid = null;
  try {
    uuid = JSON.parse(atob(document.cookie.split('; ').filter(function (c) {
      return c.substr(0, 8) === 'id_token';
    })[0].split('.')[1])).sub;
    return uuid;
  } catch (error) {
    //
  }
}
export function updateRioState(state) {
  getRioClient().updateState(state);
}